import { FieldType } from '../type';
import { I18N_CHANGE_LABEL } from '../util';
export const schema = {
    id: 'project_ui',
    name: '导航与菜单',
    fields: {
        sidebar: {
            name: '左侧菜单',
            type: FieldType.Array,
            idField: 'groupId',
            itemName: get => `菜单组 【${get('groupName')}】`,
            detailUncheckable: true,
            details: {
                i18nPatch: I18N_CHANGE_LABEL,
            },
        },
        navlink: {
            name: '顶部导航',
        },
    },
};
